import * as styles from "./YearPickerValue.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { useYearPickerContext } from "./YearPicker.context";
import type { YearPickerValueProps } from "./YearPicker.types";

export function YearPickerValue({
  placeholder = "----",
  className,
}: YearPickerValueProps): JSX.Element {
  const { selected } = useYearPickerContext();

  return (
    <span
      data-slot="year-picker-value"
      className={clsx(
        styles.value,
        null === selected && styles.placeholder,
        className,
      )}
    >
      {selected ?? placeholder}
    </span>
  );
}
